import './Main.css';

function Main() {
  
  return (
    <div className="main">
      <div className="article">
      <h4 className="mainH1">Full-stack developer, librarian</h4>
        <div className="me">A coder with years of research and humanities experience and a desire to make an impact on social justice, K.C. Chandler has overcome a number of challenges, acquiring significant skill sets for work in technical libraries, writing, or research areas, as well as startups and private companies as a junior developer. Ms. Chandler is tenacious, highly intelligent and sophisticated, and passionate in her desire to create access for the end user.
        </div>
</div>
      <aside className='left'></aside>
      <aside className='right'></aside>
</div>
  )
}

export default Main;